/**
 * Calculate invisible hit stroke around elements
 * Grows with scale
 */
export const getPaddedHitStroke = (
  visiblethickness: number,
  mininumhitarea: number,
  hitareascalefactor: number,
  scale: number
): number => {
  //ensure thin lines have hit area minimum 1
  const hitline =
    visiblethickness > mininumhitarea ? visiblethickness : mininumhitarea;

  // grow hit areas as user zooms out
  // never a hit area thinner than the actual line, never a hit area thinner than min_constant
  const scaledhitline = Math.max(
    visiblethickness,
    Math.max(hitline + hitareascalefactor * scale, mininumhitarea)
  );

  return scaledhitline;
};
